import { useQuery } from 'react-query';
import axiosClient from './axiosClient';

export const publicApi = {
  getGenders(params) {
    return axiosClient
      .get('/genders', { params })
      .then((response) => response?.data || []);
  },
  getTechnicians(params) {
    return axiosClient
      .get('/technician', { params })
      .then((response) => response?.data || []);
  },
  getReceptionists(params) {
    return axiosClient
      .get('/receptionist', { params })
      .then((response) => response?.data || []);
  },
  getQuestions(params) {
    return axiosClient
      .get('/option', { params })
      .then((response) => response?.data || []);
  },

  //
  getQCs(params) {
    return axiosClient.get('/qc', { params });
  },
  getRepairStatuses(params) {
    return axiosClient
      .get('/repairs/status', { params })
      .then((response) => response?.data ?? []);
  },
  getGeometryMultiPolygon(params) {
    return axiosClient
      .get('/geometry-multipolygon', { params })
      .then((response) => response?.data);
  },
};

export const useGenders = ({ params, options } = {}) => {
  return useQuery({
    queryKey: ['public', 'genders', params],
    queryFn: () => publicApi.getGenders(params),
    ...options,
  });
};

export const useTechnicians = ({ params, options } = {}) => {
  return useQuery({
    queryKey: ['public', 'technicians', params],
    queryFn: () => publicApi.getTechnicians(params),
    ...options,
  });
};

export const useReceptionists = ({ params, options } = {}) => {
  return useQuery({
    queryKey: ['public', 'receptionists', params],
    queryFn: () => publicApi.getReceptionists(params),
    ...options,
  });
};

export const useQuestions = ({ params, options } = {}) => {
  return useQuery({
    queryKey: ['public', 'questions', params],
    queryFn: () => publicApi.getQuestions(params),
    ...options,
  });
};

///

export const useQCs = ({ params, options } = {}) => {
  return useQuery({
    queryKey: ['qcs', 'list', params],
    queryFn: () => publicApi.getQCs(params),
    ...options,
  });
};

export const useRepairStatuses = ({ params, options } = {}) => {
  return useQuery({
    queryKey: ['repair-status', 'list', params],
    queryFn: () => publicApi.getRepairStatuses(params),
    ...options,
  });
};

export const useGeometryMultiPolygon = ({ params, options } = {}) => {
  return useQuery({
    queryKey: ['geometry', 'list', params],
    queryFn: () => publicApi.getGeometryMultiPolygon(params),
    ...options,
  });
};
